<template>
  <b-navbar toggleable="lg"
            type="dark"
            sticky
            variant="success">
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-navbar-brand>
      <b-icon icon="basket"></b-icon>
      桶柑果實外觀分級系統
    </b-navbar-brand>
    <b-collapse id="nav-collapse"
                is-nav>
      <b-navbar-nav>
        <b-nav-item :href="rootUrl">首頁</b-nav-item>
        <b-nav-item @click.prevent="$router.push({ name: 'Home'}).catch(()=>{})" :class="{ active: $route.name === 'Home'}">分級系統</b-nav-item>
        <b-nav-item @click.prevent="$router.push({ name: 'List'}).catch(()=>{})" :class="{ active: $route.name === 'List'}">分級表</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'NavigationBar',
  components: {},
  filters: {},
  mixins: {},
  props: {},
  data: function () {
    return {
      rootUrl: '/'
    }
  },
  computed: {},
  watch: {},
  created () {
    this.rootUrl = this.rootUrl + location.search
  },
  methods: {}
}
</script>
